import { Routes } from '@angular/router';
import { AuthGuardWithForcedLogin } from './auth/auth-guard-with-forced-login.service';
import { ErrorComponent } from 'ngx-q360-lib';
import { provideStates } from '@ngxs/store';
import { WorkItemState } from '@global-shared/store/work-item.state';
import { ProjectIntegrationState } from '@project/integrations/store/project-integration.state';
import { HoursState } from '@app/main/pages/hours/store/hours.state';
import { officeRouteGuard } from './auth/office-route-guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'pages',
    pathMatch: 'full',
  },
  { path: 'callback', redirectTo: 'pages', pathMatch: 'full' },
  {
    path: 'pages',
    loadChildren: () => import('./main/pages/pages.routes').then((m) => m.routes),
    canActivate: [AuthGuardWithForcedLogin, officeRouteGuard],
    providers: [provideStates([WorkItemState])],
  },
  {
    path: 'office',
    loadChildren: () => import('./main/pages/office-pages/office-pages.routes').then((m) => m.routes),
    canActivate: [AuthGuardWithForcedLogin, officeRouteGuard],
    providers: [provideStates([WorkItemState, ProjectIntegrationState, HoursState])],
  },
  {
    path: 'error',
    pathMatch: 'full',
    component: ErrorComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    component: ErrorComponent,
    data: { error: { status: 404 } },
  },
];
